import { parseJwt } from './parseJwt';

export const isOldToken = (token: string): boolean => {
  const payload = parseJwt(token);
  return 'project_id' in payload || 'organization_id' in payload || 'conversation_id' in payload;
};
